// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://jhbgdtjvjzukujccwzvw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpoYmdkdGp2anp1a3VqY2N3enZ3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTUwODAzMzUsImV4cCI6MjA3MDY1NjMzNX0.N4KlJ-El0OtMBG2QNbijurlhjHXoWcendZE1iF9Zv8g";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});